import { render, staticRenderFns } from "./suggestion_diff_header.vue?vue&type=template&id=b77e2fd4&vue3"
import script from "./suggestion_diff_header.vue?vue&type=script&lang=js&vue3"
export * from "./suggestion_diff_header.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports